import { ProductServiceCheckboxProps, ProductCombinedServicesElement } from './types';
import { MouseEventHandler, useState } from 'react';
import { ProductServicesElement } from '@package/core';
import styles from './ProductServiceCheckbox.module.css';
import FormCheckbox from '@base/components/src/FormCheckbox';
import MissingItemsModal from '../MissingItemModal';
import AnchorDialog from '@base/components/src/AnchorDialog';
import Spinner from '@base/components/src/Spinner';

const ProductServiceCheckbox = ({
  deleteService,
  services,
  addProductService,
  productSku,
}: ProductServiceCheckboxProps) => {
  const [selectedServices, setSelectedServices] = useState<Array<ProductCombinedServicesElement>>(services);
  const [loadServiceId, setLoadServiceId] = useState<number>(-1);

  const handleAddCombinedProduct = async (service: ProductServicesElement) => {
    try {
      if (loadServiceId !== -1) return;
      setLoadServiceId(service.id);
      setSelectedServices((prevServices) =>
        prevServices.map((item: ProductServicesElement) => {
          if (item.id === service.id) {
            return { ...item, selected: !item.selected };
          } else {
            return item;
          }
        }),
      );
      if (service.selected && deleteService) {
        await deleteService(service.sku);
        return;
      }

      await addProductService({ ...service });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadServiceId(-1);
    }
  };

  return (
    <>
      <div data-testid="services-checkbox-container" className={styles.checkboxGroupContainer}>
        {selectedServices.map((service) => (
          <div data-testid="service-radio-button" key={service.id} className={styles.container}>
            {service.canAddToCart ? (
              <>
                <FormCheckbox
                  id={service.id.toString()}
                  value={service.selected}
                  label={service.name}
                  onChange={() => handleAddCombinedProduct(service)}
                  labelClick
                  checkboxControllerClassName={styles.checkboxController}
                  checkboxMainContainerClasses={styles.checkboxContainer}
                />
                <AnchorDialog
                  contentClassName={styles.serviceModal}
                  dialogHeaderClassName={styles.serviceRadioDialogHeader}
                  anchorContent={(open: () => void) => (
                    <img
                      src="/marketplace-static/images/icons/infoIcon.svg"
                      alt="info icon"
                      width={14}
                      height={14}
                      className={`${styles.infoIcon} infoIcon`}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        open();
                      }}
                    />
                  )}
                >
                  {(_: any, close: () => void) => (
                    <MissingItemsModal
                      infoMode
                      productSku={productSku}
                      serviceId={service.id}
                      addService={() => handleAddCombinedProduct(service)}
                      closeModal={close}
                    />
                  )}
                </AnchorDialog>
                {loadServiceId === service.id && (
                  <div className={styles.opportunityDesc}>
                    <Spinner className={styles.serviceRadioSpinner} width="w-3" height="h-3" />
                    <div className={styles.addToOrder}>
                      {service.selected ? 'Adding to Order' : 'Removing from Order'}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <AnchorDialog
                contentClassName={styles.serviceModal}
                dialogHeaderClassName={styles.serviceRadioDialogHeader}
                anchorContent={(open: MouseEventHandler<HTMLSpanElement> | undefined) => (
                  <span onClick={open} className={styles.container}>
                    <FormCheckbox
                      id={service.id.toString()}
                      value={service.selected}
                      label={service.name}
                      onChange={() => {}}
                      labelClick
                      checkboxControllerClassName={styles.checkboxController}
                      checkboxMainContainerClasses={styles.checkboxContainer}
                    />
                    <img
                      src="/marketplace-static/images/icons/infoIcon.svg"
                      alt="info icon"
                      width={14}
                      height={14}
                      className={`${styles.infoIcon} infoIcon`}
                    />
                  </span>
                )}
              >
                {(_: any, close: () => void) => (
                  <MissingItemsModal
                    productSku={productSku}
                    serviceId={service.id}
                    addService={() => handleAddCombinedProduct(service)}
                    closeModal={close}
                  />
                )}
              </AnchorDialog>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductServiceCheckbox;
